export class WebRecadPublicoAlvoEntidade {
  public OID_RECAD_PUBLICO_ALVO: number;
  public OID_RECAD_CAMPANHA: number;
  public CD_FUNDACAO: string;
  public NUM_INSCRICAO: string;
  public SEQ_RECEBEDOR: number;
  public IND_SITUACAO_RECAD: string;
  public DTA_EFETIVACAO?: Date;
  public NOM_USUARIO_ACAO: string;
  public DTA_TERMINO: Date;
  public CD_TIPO_RECEBEDOR: string;
  public CD_ESPECIE_INSS: string;
  public TEXTO_RECAD: string;
  public GRUPO_RECADASTRAMENTO: string;
  public NUM_MATRICULA: string;
  public NOM_CAMPANHA: string;
  public IND_FLUXO_RECAD: string;
}
